import { Api } from '../../../lib/api';
import {
    TEST_BLOCK_TYPE__IL_RL,
    TEST_BLOCK_TYPE__Polarity,
    EQUIPMENT_TYPE__PT1,
    EQUIPMENT_TYPE__RL1
} from '@shared/constants/constants';
export class TestPlan {
    static async create(data) {
        let response = await Api.createTestPlan(data);

        return response;
    }
    
    static async update(testPlanUuid, data) {
        let testPlan = {
            name: data.name,
            cableCoreSize: data.assembly.coreSize,
            wizardData: data.wizardData,
            serialNumScheme: data.serialNumScheme,
            autoPrintBarcode: data.autoPrintBarcode,
            autoIncrement: data.autoIncrement
        };
        let testBlockIds = [];
        let customFields = [];
        if ('customFields' in data && Array.isArray(data.customFields)) {
            for (let customField of data.customFields) {
                customFields.push({
                    id: customField.id,
                    name: customField.name,
                    mandatory: customField.required
                });
            }
        }
        if ('label' in data && typeof data.label !== 'undefined') {
            testPlan.label = data.label;
        }
        for (let equipment of data.equipment) {
            if (equipment.type === EQUIPMENT_TYPE__RL1) {
                let testBlock = {
                    name: equipment.testBlockName,
                    type: TEST_BLOCK_TYPE__IL_RL,
                    cableCoreSize: data.assembly.coreSize,

                    templateSpec: {
                        assemblyType: data.assembly.assemblyType,
                        hybridAssembly: data.assembly.hybridAssembly,
                        assemblyLength: data.assembly.assemblyLength,
                        fibersPerCable: data.assembly.fibersPerCable,
                        cablesPerAssembly: data.assembly.cablesPerAssembly,
                        coreSize: data.assembly.coreSize,
                        ilRefLimit: data.wizardData.assembly.ilRefLimit,
                        customFields: customFields,
                        procedures: [
                            {
                                type: TEST_BLOCK_TYPE__IL_RL,
                                id: 1,
                                name: 'name',
                                realTimeDisplay: equipment.realTimeDisplay,
                                testPlanDisplay: equipment.testPlanDisplay,
                                showDutLength: equipment.showDutLength,
                                results: equipment.results,
                                allowableRetryCount: equipment.allowableRetryCount,
                                retryFailedChannels: equipment.retryFailedChannels,
                                fastFail: equipment.fastFail,
                                fiberMap: equipment.fiberMap,
                                wavelengths: data.assembly.wavelengths,
                                autoStart: equipment.autoStart,
                                rlMode: equipment.rlMode,
                                insertionLossTest: equipment.insertionLossTest,
                                returnLossTest: equipment.returnLossTest,
                                pauseMap: equipment.pauseBefore,
                                pauseMessages: equipment.pauseMessages,
                                referenceMap: equipment.referenceMap,
                                referencePauseMap: equipment.referencePauseBefore,
                                referencePauseMessages: equipment.referencePauseMessages,
                                cableMap: data.assembly.cableMap_1,
                                additionalSpecs: data.wizardData.additionalSpecs,
                                ilComp: data.wizardData.ilComp,
                                ilMinimumLimit: data.assembly.ilMinimumLimit,
                                trackDUTCount: data.wizardData.trackDUTCount,

                                requirements: {
                                    ilA: equipment.tests.ilA,
                                    ilB: equipment.tests.ilB,
                                    rlA: equipment.tests.rlA,
                                    rlB: equipment.tests.rlB,
                                    rlTotal: equipment.tests.rlTotal,
                                    length: equipment.tests.length
                                }
                            }
                        ]
                    }
                };
                if (equipment.insertionLossTest) {
                    testBlock.templateSpec.procedures[0] = {
                        ...testBlock.templateSpec.procedures[0],
                        ilLimit: equipment.ilLimit,
                        ilDetector: equipment.ilDetector
                    };
                }
                if (equipment.returnLossTest) {
                    testBlock.templateSpec.procedures[0] = {
                        ...testBlock.templateSpec.procedures[0],
                        tjA: equipment.tj1
                    };
                    if ('tj2' in equipment) {
                        testBlock.templateSpec.procedures[0].tjB = equipment.tj2;
                    }
                    if ('rlLimitA' in equipment) {
                        testBlock.templateSpec.procedures[0].rlLimitA = equipment.rlLimitA;
                    }
                    if ('rlLimitB' in equipment) {
                        testBlock.templateSpec.procedures[0].rlLimitB = equipment.rlLimitB;
                    }
                    if ('rlLimitTotal' in equipment) {
                        testBlock.templateSpec.procedures[0].rlLimitTotal = equipment.rlLimitTotal;
                    }
                }

                let response = await Api.createTestBlock(testBlock);
                testBlockIds.push(response.id);
            }

            //
            // PT1
            //
            if (equipment.type === EQUIPMENT_TYPE__PT1) {
                let testBlock = {
                    name: 'Polarity Test Block', // TODO: Replace this placeholder
                    type: TEST_BLOCK_TYPE__Polarity,
                    cableCoreSize: data.assembly.coreSize,
                    templateSpec: {
                        assemblyType: data.assembly.assemblyType,
                        hybridAssembly: data.assembly.hybridAssembly,
                        assemblyLength: data.assembly.assemblyLength,
                        fibersPerCable: data.assembly.fibersPerCable,
                        cablesPerAssembly: data.assembly.cablesPerAssembly,
                        coreSize: data.assembly.coreSize,
                        customFields: customFields,
                        procedures: [
                            {
                                type: TEST_BLOCK_TYPE__Polarity,
                                id: 1,
                                name: 'name',
                                polarityMapping: equipment.polarity,
                                trackDUTCount: data.wizardData.trackDUTCount
                            }
                        ]
                    }
                };
                let response = await Api.createTestBlock(testBlock);
                testBlockIds.push(response.id);
            }
        }
        testPlan.testBlocks = testBlockIds;
        let response = await Api.updateTestPlan(testPlanUuid, testPlan);
        return response;
    }
}
